/* Purpose: Pop up to confirm a delete action
 * Props: ClientID (str)
 *        LoanID (str)
 *        credentials (map)
 *        onHide (func)
 * Author: R. Markowitz (May 2025)
 * Dev Notes: 
*/

import {Button, Spinner} from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import React, {useState} from 'react';
import { Form } from 'react-bootstrap';

const ConfirmDelete = (props) => {
    const ClientID = props.ClientID;
    const LoanID = props.LoanID;
    const credentials = props.credentials;
    const [fieldValue, setFieldValue] = useState("");
    const [confirmed, setConfirmed] = useState(false);
    const [deleting, setDeleting] = useState(false);

    // When the user types in the text field, check if the value matched the loanId.
    // If the value matches the loanID, set confirmed to true otherwise confirmed should be false
    const handleTextChange = (value) => {
        setFieldValue(value);

        if (value === LoanID){
            setConfirmed(true)
        }else if(confirmed){
            setConfirmed(false)
        }
    }

    const deleteLoan = async() => {
        // Set deleting to true to put a spinner in the delete button
        setDeleting(true)

        // Delete the loan from dynamodb
        try{
            const url = "https://f0ll5x1c4l.execute-api.us-east-1.amazonaws.com/deleteLoan"
            const params = {
                "method": "POST",
                "body": JSON.stringify({
                    "ClientID": ClientID,
                    "LoanID": LoanID,
                    "credentials": credentials
                })
            };

            const response = await fetch(url, params);
            if(response.ok){
                alert("Loan " + LoanID + " was successfully deleted.")
            }else{
                alert("Something went wrong while deleting loan " + LoanID + ". ERROR: " + response.statusText)
            }
        }catch (error){
            alert("Something went wrong while deleting loan " + LoanID + ". ERROR: " + error)
        }
        setDeleting(false)
        props.onHide();
    }

    return(
        <Modal
        show = {true}
        onHide={props.onHide}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        >
        <Modal.Header closeButton>
            <Modal.Title id="confirm-delete">
                Delete loan "{LoanID}"?
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
                <p>This will permanently delete loan "{LoanID}" from your account. Deleting this loan can not be undone.</p> 
                <p  className = "bold">To confirm deletion, enter <span className = "italic">{LoanID} </span> in the field.</p>
                <Form.Control
                    id = "confirmation"
                    onChange = {(event) => handleTextChange(event.target.value)}    
                    value = {fieldValue}
                    placeholder = {LoanID}
                />
        </Modal.Body>
        <Modal.Footer>
            <Button onClick={props.onHide}>Close</Button>
            <Button disabled = {!confirmed} onClick={deleteLoan}>
                {deleting? (
                    <>
                        <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                        />
                        Deleting...
                    </>
                    
                ):<>
                    Delete
                </>} 
                   
            </Button>
        </Modal.Footer>
        </Modal>
    );
};

export default ConfirmDelete; 